<span>
	<i class="fa fa-question-circle"
		tabindex="0"
		[matTooltip]="innerVal"
		matTooltipPosition="above">
	</i>
</span>